import { Path } from '@/main/router/routerPath';

import { NAME, CRUMB_LABEL_KEY } from './constants';
import List from './List.vue';

export const router = new Path(NAME, { List }, CRUMB_LABEL_KEY);
